module.exports = __webpack_public_path__ + "assets/img/banner-13.9748b127.jpg";